import React, { useEffect } from 'react';
import { HashRouter, BrowserRouter } from 'react-router-dom';

export const HybridRouterWrapper = ({ children }: { children: React.ReactNode }) => {
  if(typeof window === "undefined") {
    return null;
  }

  const currentPath = window.location.pathname + window.location.hash;
  
  // Use HashRouter only if path starts with /your-orders#/ or /your-orders/#/
  if (currentPath.startsWith('/your-orders#/') || 
    currentPath.startsWith('/your-orders/#/')) {
    return <HashRouter>{children}</HashRouter>;
  }
  
  // Use BrowserRouter if path does not contain #/
  if (!currentPath.includes('#/')) {
    return <BrowserRouter basename='/your-orders'>{children}</BrowserRouter>;
  }

  // Invalid url, redirect to homepage
  useEffect(() => {
    window.location.replace('/your-orders/');
  }, []);

  return null;
};